<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Icard Master </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center" class="no-display">
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="field.ut" :items="user_type_list" item-text="name"
                        item-value="id" label="User Type" outlined persistent-hint
                        hint="Please Select User Type"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-btn rounded class="button mt-6" v-if="field.ut" @click="getIcardMaster();show=true"
                        :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <!-- {{icard_details}} -->
            <span v-if="field.ut!=null && show">
                <v-row dense justify="center">
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field outlined dense label="Logo" v-model="field.logo"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field outlined dense label="Website" v-model="field.website"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field outlined dense label="Email" v-model="field.email"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field outlined dense type="text" label="School Contact"
                            v-model="field.school_contact"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field outlined dense label="School Name" v-model="field.school_name"
                            target="_blank"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            <v-text-field outlined dense label="Watermark" v-model="field.watermark"></v-text-field>
                            <a class="ml-2 pt-2" v-if="field.watermark" :href="field.watermark">
                                <v-icon color="primary">mdi-eye</v-icon>
                            </a>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            <v-text-field outlined dense label="Watermark Back" v-model="field.watermark_back"
                                target="_blank"></v-text-field>
                            <a class="ml-2 pt-2" v-if="field.watermark_back" :href="field.watermark_back">
                                <v-icon color="primary">mdi-eye</v-icon>
                            </a>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field outlined dense label="Version No" v-model="field.version_no"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-row dense>
                            <v-text-field outlined dense label="sign" v-model="field.sign"
                                target="_blank"></v-text-field>
                            <a class="ml-2 pt-2" v-if="field.sign" :href="field.sign">
                                <v-icon color="primary">mdi-eye</v-icon>
                            </a>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-textarea color="#0f2027" class="mt-2" v-model="field.instruction" label="Instruction"
                            outlined counter rows="5" auto-grow></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-textarea color="#0f2027" class="mt-2" v-model="field.school_address" label="School Address"
                            outlined dense></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-textarea color="#0f2027" class="mt-2" v-model="field.heading" label="Heading" outlined
                            dense></v-textarea>
                    </v-col>
                    <v-btn rounded class="button mt-6" v-if="field.ut" @click="saveIcardMaster()"
                        :loading="loader">Save</v-btn>
                </v-row>
            </span>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                show:false,
                loader: false,
                color: "",
                snackbar: false,
                // extraBreadcrumbItems: [
                    

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                search: "",
                snackbar_msg: null,
                overlay:false,
                user_type_list:[],
                icard_details:[],
                field:{
                    ut:null,
                    id:null,
                    heading: null, //html
                    logo: null,  //file
                    instruction: null, //comma seperated
                    website: null,
                    email: null,
                    school_address: null,
                    school_contact: null,
                    school_name: null,
                    watermark: null, //file
                    watermark_back: null, //file
                    version_no: null,
                    sign: null, //file
                }
            };
        },
      
        methods: {
             onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async onload() {
                this.overlay = true;
                try {
                    const res = await axios.post("/Icard/getUserType");
                    if (res.data.flag == "YES") {
                        this.user_type_list = res.data.user_type_list
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                   // this.markAllSelected();
                }
            },
            async getIcardMaster() {
                const formdata = {
                    ut: this.field.ut,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Icard/getIcardMaster", formdata);
                    if (res.data.flag == "YES") {
                        this.icard_details = res.data.icard_details[0]
                        this.field.heading = this.icard_details.heading //html
                        this.field.logo = this.icard_details.logo  //file
                        this.field.instruction = this.icard_details.instruction//comma seperated
                        this.field.website = this.icard_details.website
                        this.field.email = this.icard_details.email
                        this.field.school_address = this.icard_details.school_address
                        this.field.school_contact = this.icard_details.school_contact
                        this.field.school_name = this.icard_details.school_name
                        this.field.watermark = this.icard_details.watermark //file
                        this.field.watermark_back = this.icard_details.watermark_back //file
                        this.field.version_no = this.icard_details.version_no
                        this.field.sign = this.icard_details.sign //file
                        this.field.id = this.icard_details.id //file
                    } 
                    else {
                     //   this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                   // this.markAllSelected();
                }
            },
            async saveIcardMaster() {
                this.overlay = true;
                try {
                    const res = await axios.post("/Icard/saveIcardMaster", this.field);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Saved Successfully..");
                       this.getIcardMaster()
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                   // this.markAllSelected();
                }
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
